var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgResetIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 75,
    viewBox: "0 0 85 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.0516 65.625C22.5876 65.625 10.0516 53.033 10.0516 37.5C10.0516 21.967 22.5876 9.375 38.0516 9.375C53.5156 9.375 66.0516 21.967 66.0516 37.5H58.9806C57.2416 37.5 56.1548 39.2756 57.0243 40.696L68.762 59.8722C69.6314 61.2926 71.8051 61.2926 72.6745 59.8722L84.4123 40.696C85.2817 39.2756 84.1949 37.5 82.456 37.5H75.3849C75.3849 16.7893 58.6702 0 38.0516 0C17.433 0 0.718262 16.7893 0.718262 37.5C0.718262 58.2107 17.433 75 38.0516 75C40.6289 75 42.7183 72.9013 42.7183 70.3125C42.7183 67.7237 40.6289 65.625 38.0516 65.625Z",
    fill: "#ff6633"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResetIcon);
export default __webpack_public_path__ + "static/media/reset-icon.e2fc59f2be7de0e552f0192fff82e71e.svg";
export { ForwardRef as ReactComponent };